import { render, staticRenderFns } from "./QCheckbox.vue?vue&type=template&id=2b63687a&"
import script from "./QCheckbox.vue?vue&type=script&lang=js&"
export * from "./QCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports